class Password {
  constructor(data, redirectUrl, storageKey = 'authenticated') {
    this.data = data;
    this.redirectUrl = redirectUrl;
    this.storageKey = storageKey;
    this.passwordGatePage = 'password.html';

    // Add authentication class immediately if authenticated
    if (this.isAuthenticated()) {
      document.body.classList.add('authenticated');
    }

    this.init();
  }

  isAuthenticated() {
    return localStorage.getItem(this.storageKey) === 'true';
  }

  authenticateUser() {
    localStorage.setItem(this.storageKey, 'true');
    document.body.classList.add('authenticated');
  }

  isOnPasswordGatePage() {
    return window.location.pathname.endsWith(this.passwordGatePage);
  }

  redirectToPasswordGate() {
    if (!this.isOnPasswordGatePage()) {
      window.location.href = this.passwordGatePage;
    }
  }

  validatePassword(enteredPassword) {
    return enteredPassword === this.data;
  }

  handlePasswordSubmission(passwordInputId, errorMessageId) {
    const passwordInput = document.getElementById(passwordInputId);
    const errorMessage = document.getElementById(errorMessageId);
    const enteredPassword = passwordInput.value.trim();

    if (this.validatePassword(enteredPassword)) {
      this.authenticateUser();
      window.location.href = this.redirectUrl;
    } else {
      errorMessage.style.display = 'block';
      passwordInput.value = '';
    }
  }

  protectPage() {
    if (!this.isAuthenticated()) {
      this.redirectToPasswordGate();
    }
  }

  initPasswordGate(passwordInputId, submitButtonId, errorMessageId) {
    const submitButton = document.getElementById(submitButtonId);
    submitButton.addEventListener('click', () => {
      this.handlePasswordSubmission(passwordInputId, errorMessageId);
    });
  }

  init() {
    if (!this.isAuthenticated() && !this.isOnPasswordGatePage()) {
      this.redirectToPasswordGate();
    }
  }
}

export default Password;
